<template>
  <div v-if="isMerger">
    <template v-if="!isMyTurn">
      <section-title highlight>
        Waiting for {{ mergingPlayer.name }} to analyze their {{ hotelBeingRemovedName }} portfolio
      </section-title>
    </template>

    <template v-else>
      <section-title highlight>
        Your turn: Choose what to do with your {{ hotelBeingRemovedName }} stocks
      </section-title>

      <merger-stock-section />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {NS_GAME_STATE} from "@/store/constants";
import SectionTitle from "@/components/SectionTitle";
import MergerStockSection from "@/components/board/MergerStockSection";

export default {
  name: 'MergerSection',

  components: {
    MergerStockSection,
    SectionTitle,
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'isMerger',
      'localPlayer',
      'localPlayerId',
      'mergingPlayerId',
      'players',
      'mergingHotelId',
    ]),

    hotelBeingRemovedName() {
      return this.mergingHotelId;
    },

    mergingPlayer() {
      return this.players[this.mergingPlayerId];
    },

    isMyTurn() {
      return this.localPlayerId === this.mergingPlayerId;
    },
  },
}
</script>

<style scoped>
.bold {
  font-weight: 900;
}
</style>
